module.exports = __webpack_public_path__ + "static/media/8-4.17404963.mp3";